
define('text!modules/creatives/display/templates/review_grid_header.html',[],function () { return '{{#headers}}\n<div class="column header {{name}}">\n    {{#checkable}}\n    <div class="column checkbox-input">\n        <div class="checkbox {{checked}}" data-id="all"></div>\n    </div>\n    {{/checkable}}\n    <div class="column">{{{label}}}</div>\n</div>\n{{/headers}}\n';});

